import { render } from "./NewCar.vue?vue&type=template&id=50328140&scoped=true"
import script from "./NewCar.vue?vue&type=script&lang=js"
export * from "./NewCar.vue?vue&type=script&lang=js"

import "./NewCar.vue?vue&type=style&index=0&id=50328140&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50328140"]])

export default __exports__